import { keysToCamelCase } from "@jti/fe-common";
import { type ApiMagentoGetProductsDetails, type MagentoGetProductsDetails } from "@jti/magento-types";

export const getProductDetailsByResponseMock = (): ApiMagentoGetProductsDetails => ({
  currency: {
    base_currency_code: "EUR",
    base_currency_symbol: "€",
  },
  products: {
    aggregations: [
      {
        attribute_code: "price",
        label: "Price",
        options: [
          {
            count: 1,
            label: "400-410",
            value: "400_410",
          },
        ],
      },
      {
        attribute_code: "category_uid",
        label: "Category",
        options: [
          {
            count: 2,
            label: "Products",
            value: "NDQ=",
          },
        ],
      },
      {
        attribute_code: "number_of_packs_bucket",
        label: "number_of_packs_bucket",
        options: [
          {
            count: 4,
            label: "0",
            value: "0",
          },
        ],
      },
      {
        attribute_code: "number_of_sticks_bucket",
        label: "number_of_sticks_bucket",
        options: [
          {
            count: 4,
            label: "0",
            value: "0",
          },
        ],
      },
      {
        attribute_code: "flavor",
        label: "Flavor",
        options: [
          {
            count: 2,
            label: "Silver",
            value: "15",
          },
          {
            count: 2,
            label: "Amber",
            value: "16",
          },
        ],
      },
      {
        attribute_code: "color",
        label: "Colour",
        options: [
          {
            count: 2,
            label: "Silver",
            value: "18",
          },
          {
            count: 2,
            label: "Red",
            value: "29",
          },
        ],
      },
    ],
    items: [
      {
        sku: "sticks-carton-bronze-subscription",
        __typename: "BundleProduct",
        id: 13613,
        name: "Camel Silver - carton - subscription",
        flavor: 15,
        color: null,
        categories: [
          {
            name: "Products",
          },
        ],
        stock_status: "IN_STOCK",
        flavour_details: [
          {
            name: "Bronze",
            description: "Smoother than you think",
            attributes: [
              {
                id: 1,
                name: "Intensity",
                sort_order: 3,
                value: "2.5",
              },
              {
                id: 2,
                name: "Flavor",
                sort_order: 4,
                value: "5",
              },
            ],
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/r/bronze_1_1.jpg",
        },
        media_gallery: [
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3_2_1.jpg",
            role: ["image", "small_image", "thumbnail"],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 300,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 600,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 900,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 1200,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 1500,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 300,
              currency: "EUR",
            },
            regular_price: {
              value: 333.33,
              currency: "EUR",
            },
            discount: {
              percent_off: 10,
            },
          },
        },
        items: [
          {
            title: "packs",
            required: true,
            type: "multi",
            __typename: "BundleItem",
            sku: "sticks-carton-silver-subscription",
            option_id: 4651,
            qty: 10,
            options: [
              {
                id: 4736,
                label: "Camel Silver - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13601,
                  name: "Camel Silver - Pack",
                  sku: "sticks-pack-silver",
                  flavor: 15,
                  stock_status: "IN_STOCK",
                  color_label: "",
                  flavour_details: [
                    {
                      name: "Silver",
                      description: "Fresh kick",
                      attributes: [
                        {
                          id: 9,
                          name: "Intensity",
                          sort_order: 17,
                          value: "4.5",
                        },
                        {
                          id: 10,
                          name: "Flavor",
                          sort_order: 18,
                          value: "1.5",
                        },
                        {
                          id: 11,
                          name: "Strength",
                          sort_order: 19,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3_2_1.jpg",
                  },
                  media_gallery: [
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3.jpg",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                      role: [],
                    },
                  ],
                },
              },
            ],
            all_options: [
              {
                id: 4736,
                label: "Camel Silver - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13601,
                  name: "Camel Silver - Pack",
                  sku: "sticks-pack-silver",
                  flavor: 15,
                  stock_status: "IN_STOCK",
                  color_label: "Silver",
                  flavour_details: [
                    {
                      name: "Silver",
                      description: "Fresh kick",
                      attributes: [
                        {
                          id: 9,
                          name: "Intensity",
                          sort_order: 17,
                          value: "4.5",
                        },
                        {
                          id: 10,
                          name: "Flavor",
                          sort_order: 18,
                          value: "1.5",
                        },
                        {
                          id: 11,
                          name: "Strength",
                          sort_order: 19,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                  },
                  media_gallery: [
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3.jpg",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                      role: [],
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
      {
        sku: "sticks-mix-n-match-subscription",
        __typename: "BundleProduct",
        id: 13612,
        name: "Camel Amber - carton - subscription",
        flavor: 16,
        color: null,
        categories: [
          {
            name: "Products",
          },
        ],
        stock_status: "IN_STOCK",
        flavour_details: [
          {
            name: "Silver",
            description: "Fresh kick",
            attributes: [
              {
                id: 9,
                name: "Intensity",
                sort_order: 17,
                value: "4.5",
              },
              {
                id: 10,
                name: "Flavor",
                sort_order: 18,
                value: "1.5",
              },
              {
                id: 11,
                name: "Strength",
                sort_order: 19,
                value: "2.5",
              },
            ],
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/m/n/mnm_1.jpg",
        },
        media_gallery: [
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_2_1.jpg",
            role: ["image", "small_image", "thumbnail"],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 400,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 800,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 1200,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 1600,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 2000,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 400,
              currency: "EUR",
            },
            regular_price: {
              value: 444.44,
              currency: "EUR",
            },
            discount: {
              percent_off: 10,
            },
          },
        },
        items: [
          {
            title: "packs",
            required: true,
            type: "multi",
            __typename: "BundleItem",
            sku: "sticks-carton-amber-subscription",
            option_id: 4650,
            qty: 10,
            options: [
              {
                id: 4735,
                label: "Camel Amber - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13604,
                  name: "Camel Amber - Pack",
                  sku: "sticks-pack-amber",
                  flavor: 16,
                  stock_status: "IN_STOCK",
                  color_label: "",
                  flavour_details: [
                    {
                      name: "Amber",
                      description: "Stronger fresh kick",
                      attributes: [
                        {
                          id: 13,
                          name: "Intensity",
                          sort_order: 22,
                          value: "0.5",
                        },
                        {
                          id: 14,
                          name: "Flavor",
                          sort_order: 23,
                          value: "4.5",
                        },
                        {
                          id: 15,
                          name: "Strength",
                          sort_order: 24,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_2.jpg",
                  },
                  media_gallery: [
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_1.jpg",
                      role: [],
                    },
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                  ],
                },
              },
            ],
            all_options: [
              {
                id: 4735,
                label: "Camel Amber - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13604,
                  name: "Camel Amber - Pack",
                  sku: "sticks-pack-amber",
                  flavor: 16,
                  stock_status: "IN_STOCK",
                  color_label: "Red",
                  flavour_details: [
                    {
                      name: "Amber",
                      description: "Stronger fresh kick",
                      attributes: [
                        {
                          id: 13,
                          name: "Intensity",
                          sort_order: 22,
                          value: "0.5",
                        },
                        {
                          id: 14,
                          name: "Flavor",
                          sort_order: 23,
                          value: "4.5",
                        },
                        {
                          id: 15,
                          name: "Strength",
                          sort_order: 24,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                  },
                  media_gallery: [
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_1.jpg",
                      role: [],
                    },
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
      {
        sku: "sticks-pack-bronze",
        __typename: "SimpleProduct",
        id: 13604,
        name: "Camel Amber - Pack",
        flavor: 16,
        color: 29,
        categories: [],
        stock_status: "IN_STOCK",
        flavour_details: [
          {
            name: "Bronze",
            description: "Smoother than you think",
            attributes: [
              {
                id: 1,
                name: "Intensity",
                sort_order: 3,
                value: "2.5",
              },
              {
                id: 2,
                name: "Flavor",
                sort_order: 4,
                value: "5",
              },
            ],
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/static/version1732026409/frontend/Magento/luma/en_US/Magento_Catalog/images/product/placeholder/thumbnail.jpg",
        },
        media_gallery: [
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_1.jpg",
            role: [],
          },
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
            role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 44.44,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 88.88,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 133.32,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 177.76,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 222.2,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 44.44,
              currency: "EUR",
            },
            regular_price: {
              value: 44.44,
              currency: "EUR",
            },
            discount: {
              percent_off: 0,
            },
          },
        },
      },
      {
        sku: "sticks-pack-gold",
        __typename: "SimpleProduct",
        id: 13601,
        name: "Camel Silver - Pack",
        flavor: 15,
        color: 18,
        categories: [],
        stock_status: "IN_STOCK",
        flavour_details: [
          {
            name: "Gold",
            description: "Rich as Bezos",
            attributes: [
              {
                id: 5,
                name: "Intensity",
                sort_order: 8,
                value: "4.5",
              },
              {
                id: 6,
                name: "Flavor",
                sort_order: 9,
                value: "1.5",
              },
              {
                id: 7,
                name: "Strength",
                sort_order: 10,
                value: "4.5",
              },
            ],
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
        },
        media_gallery: [
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3.jpg",
            role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
          },
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
            role: [],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 33.33,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 66.66,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 99.99,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 133.32,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 166.65,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 33.33,
              currency: "EUR",
            },
            regular_price: {
              value: 33.33,
              currency: "EUR",
            },
            discount: {
              percent_off: 0,
            },
          },
        },
      },
      {
        sku: "sticks-carton-silver-subscription",
        __typename: "BundleProduct",
        id: 13613,
        name: "Camel Silver - carton - subscription",
        stock_status: "IN_STOCK",
        flavor: 15,
        color: null,
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
        },
        categories: [
          {
            name: "Products",
          },
        ],
        flavour_details: [
          {
            name: "Silver",
            description: "Fresh kick",
            attributes: [
              {
                id: 9,
                name: "Intensity",
                sort_order: 17,
                value: "4.5",
              },
              {
                id: 10,
                name: "Flavor",
                sort_order: 18,
                value: "1.5",
              },
              {
                id: 11,
                name: "Strength",
                sort_order: 19,
                value: "2.5",
              },
            ],
          },
        ],
        media_gallery: [
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3_2_1.jpg",
            role: ["image", "small_image", "thumbnail"],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 300,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 600,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 900,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 1200,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 1500,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 300,
              currency: "EUR",
            },
            regular_price: {
              value: 333.33,
              currency: "EUR",
            },
            discount: {
              percent_off: 10,
            },
          },
        },
        items: [
          {
            option_id: 4651,
            title: "packs",
            required: true,
            type: "multi",
            qty: 10,
            __typename: "BundleItem",
            sku: "sticks-carton-silver-subscription",
            options: [
              {
                id: 4736,
                label: "Camel Silver - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13601,
                  name: "Camel Silver - Pack",
                  sku: "sticks-pack-silver",
                  flavor: 15,
                  stock_status: "IN_STOCK",
                  color_label: "",
                  flavour_details: [
                    {
                      name: "Silver",
                      description: "Fresh kick",
                      attributes: [
                        {
                          id: 9,
                          name: "Intensity",
                          sort_order: 17,
                          value: "4.5",
                        },
                        {
                          id: 10,
                          name: "Flavor",
                          sort_order: 18,
                          value: "1.5",
                        },
                        {
                          id: 11,
                          name: "Strength",
                          sort_order: 19,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                  },
                  media_gallery: [
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3.jpg",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                      role: [],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 33.33,
                        currency: "EUR",
                      },
                      regular_price: {
                        value: 33.33,
                        currency: "EUR",
                      },
                      discount: {
                        percent_off: 0,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
            ],
            all_options: [
              {
                id: 4736,
                label: "Camel Silver - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13601,
                  name: "Camel Silver - Pack",
                  sku: "sticks-pack-silver",
                  flavor: 15,
                  stock_status: "IN_STOCK",
                  color_label: "Silver",
                  flavour_details: [
                    {
                      name: "Silver",
                      description: "Fresh kick",
                      attributes: [
                        {
                          id: 9,
                          name: "Intensity",
                          sort_order: 17,
                          value: "4.5",
                        },
                        {
                          id: 10,
                          name: "Flavor",
                          sort_order: 18,
                          value: "1.5",
                        },
                        {
                          id: 11,
                          name: "Strength",
                          sort_order: 19,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                  },
                  media_gallery: [
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3.jpg",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                      role: [],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 33.33,
                        currency: "EUR",
                      },
                      regular_price: {
                        value: 33.33,
                        currency: "EUR",
                      },
                      discount: {
                        percent_off: 0,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
            ],
          },
        ],
      },
      {
        sku: "sticks-carton-silver-subscription",
        __typename: "BundleProduct",
        id: 13613,
        name: "Camel Silver - carton - subscription",
        stock_status: "IN_STOCK",
        flavor: 15,
        color: null,
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
        },
        categories: [
          {
            name: "Products",
          },
        ],
        flavour_details: [
          {
            name: "Silver",
            description: "Fresh kick",
            attributes: [
              {
                id: 9,
                name: "Intensity",
                sort_order: 17,
                value: "4.5",
              },
              {
                id: 10,
                name: "Flavor",
                sort_order: 18,
                value: "1.5",
              },
              {
                id: 11,
                name: "Strength",
                sort_order: 19,
                value: "2.5",
              },
            ],
          },
        ],
        media_gallery: [
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3_2_1.jpg",
            role: ["image", "small_image", "thumbnail"],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 300,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 600,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 900,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 1200,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 1500,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 300,
              currency: "EUR",
            },
            regular_price: {
              value: 333.33,
              currency: "EUR",
            },
            discount: {
              percent_off: 10,
            },
          },
        },
        items: [
          {
            option_id: 4651,
            title: "packs",
            required: true,
            type: "multi",
            qty: 10,
            __typename: "BundleItem",
            sku: "consumables-sticks-carton-silver-subscription",
            options: [
              {
                id: 4736,
                label: "Camel Silver - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13601,
                  name: "Camel Silver - Pack",
                  sku: "sticks-pack-silver",
                  flavor: 15,
                  stock_status: "IN_STOCK",
                  color_label: "",
                  flavour_details: [
                    {
                      name: "Silver",
                      description: "Fresh kick",
                      attributes: [
                        {
                          id: 9,
                          name: "Intensity",
                          sort_order: 17,
                          value: "4.5",
                        },
                        {
                          id: 10,
                          name: "Flavor",
                          sort_order: 18,
                          value: "1.5",
                        },
                        {
                          id: 11,
                          name: "Strength",
                          sort_order: 19,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                  },
                  media_gallery: [
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3.jpg",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                      role: [],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 33.33,
                        currency: "EUR",
                      },
                      regular_price: {
                        value: 33.33,
                        currency: "EUR",
                      },
                      discount: {
                        percent_off: 0,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
            ],
            all_options: [
              {
                id: 4736,
                label: "Camel Silver - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13601,
                  name: "Camel Silver - Pack",
                  sku: "sticks-pack-silver",
                  flavor: 15,
                  stock_status: "IN_STOCK",
                  color_label: "Silver",
                  flavour_details: [
                    {
                      name: "Silver",
                      description: "Fresh kick",
                      attributes: [
                        {
                          id: 9,
                          name: "Intensity",
                          sort_order: 17,
                          value: "4.5",
                        },
                        {
                          id: 10,
                          name: "Flavor",
                          sort_order: 18,
                          value: "1.5",
                        },
                        {
                          id: 11,
                          name: "Strength",
                          sort_order: 19,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                  },
                  media_gallery: [
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3.jpg",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                      role: [],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 33.33,
                        currency: "EUR",
                      },
                      regular_price: {
                        value: 33.33,
                        currency: "EUR",
                      },
                      discount: {
                        percent_off: 0,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
            ],
          },
        ],
      },
      {
        sku: "sticks-pack-tan",
        __typename: "SimpleProduct",
        id: 13601,
        name: "Camel Tan - Pack",
        flavor: 15,
        color: 18,
        categories: [],
        stock_status: "OUT_OF_STOCK",
        flavour_details: [
          {
            name: "Tan",
            description: "Power of grass torn from the ground",
            attributes: [
              {
                id: 17,
                name: "Intensity",
                sort_order: 27,
                value: "1.5",
              },
              {
                id: 18,
                name: "Flavor",
                sort_order: 28,
                value: "2.5",
              },
              {
                id: 19,
                name: "Strength",
                sort_order: 29,
                value: "1.5",
              },
            ],
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_tan.png",
        },
        media_gallery: [
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3.jpg",
            role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
          },
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
            role: [],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 33.33,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 66.66,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 99.99,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 133.32,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 166.65,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 33.33,
              currency: "EUR",
            },
            regular_price: {
              value: 33.33,
              currency: "EUR",
            },
            discount: {
              percent_off: 0,
            },
          },
        },
      },
      {
        sku: "sticks-mix-n-match-subscription",
        __typename: "BundleProduct",
        id: 13612,
        name: "Camel Amber - carton - subscription",
        stock_status: "IN_STOCK",
        flavor: 16,
        color: null,
        categories: [
          {
            name: "Products",
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
        },
        flavour_details: [
          {
            name: "Amber",
            description: "Stronger fresh kick",
            attributes: [
              {
                id: 13,
                name: "Intensity",
                sort_order: 22,
                value: "0.5",
              },
              {
                id: 14,
                name: "Flavor",
                sort_order: 23,
                value: "4.5",
              },
              {
                id: 15,
                name: "Strength",
                sort_order: 24,
                value: "2.5",
              },
            ],
          },
        ],
        media_gallery: [
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_2_1.jpg",
            role: ["image", "small_image", "thumbnail"],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 400,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 800,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 1200,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 1600,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 2000,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 400,
              currency: "EUR",
            },
            regular_price: {
              value: 444.44,
              currency: "EUR",
            },
            discount: {
              percent_off: 10,
            },
          },
        },
        items: [
          {
            option_id: 4650,
            title: "packs",
            required: true,
            type: "multi",
            qty: 10,
            __typename: "BundleItem",
            sku: "sticks-carton-amber-subscription",
            options: [
              {
                id: 4735,
                label: "Camel Amber - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13604,
                  name: "Camel Amber - Pack",
                  sku: "sticks-pack-amber",
                  flavor: 16,
                  stock_status: "IN_STOCK",
                  color_label: "",
                  flavour_details: [
                    {
                      name: "Amber",
                      description: "Stronger fresh kick",
                      attributes: [
                        {
                          id: 13,
                          name: "Intensity",
                          sort_order: 22,
                          value: "0.5",
                        },
                        {
                          id: 14,
                          name: "Flavor",
                          sort_order: 23,
                          value: "4.5",
                        },
                        {
                          id: 15,
                          name: "Strength",
                          sort_order: 24,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                  },
                  media_gallery: [
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_1.jpg",
                      role: [],
                    },
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                  ],
                  categories: [],
                  __typename: "SimpleProduct",
                },
              },
            ],
            all_options: [
              {
                id: 4735,
                label: "Camel Amber - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13604,
                  name: "Camel Amber - Pack",
                  sku: "sticks-pack-amber",
                  flavor: 16,
                  stock_status: "IN_STOCK",
                  color_label: "Red",
                  flavour_details: [
                    {
                      name: "Amber",
                      description: "Stronger fresh kick",
                      attributes: [
                        {
                          id: 13,
                          name: "Intensity",
                          sort_order: 22,
                          value: "0.5",
                        },
                        {
                          id: 14,
                          name: "Flavor",
                          sort_order: 23,
                          value: "4.5",
                        },
                        {
                          id: 15,
                          name: "Strength",
                          sort_order: 24,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                  },
                  media_gallery: [
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_1.jpg",
                      role: [],
                    },
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 44.44,
                        currency: "EUR",
                      },
                      regular_price: {
                        value: 44.44,
                        currency: "EUR",
                      },
                      discount: {
                        percent_off: 0,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
            ],
          },
        ],
      },
      {
        sku: "consumables-10-sticks-mix-n-match-subscription",
        __typename: "BundleProduct",
        id: 13612,
        name: "Camel Amber - carton - subscription",
        stock_status: "IN_STOCK",
        flavor: 16,
        color: null,
        categories: [
          {
            name: "Products",
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
        },
        flavour_details: [
          {
            name: "Amber",
            description: "Stronger fresh kick",
            attributes: [
              {
                id: 13,
                name: "Intensity",
                sort_order: 22,
                value: "0.5",
              },
              {
                id: 14,
                name: "Flavor",
                sort_order: 23,
                value: "4.5",
              },
              {
                id: 15,
                name: "Strength",
                sort_order: 24,
                value: "2.5",
              },
            ],
          },
        ],
        media_gallery: [
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_2_1.jpg",
            role: ["image", "small_image", "thumbnail"],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 400,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 800,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 1200,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 1600,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 2000,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 400,
              currency: "EUR",
            },
            regular_price: {
              value: 444.44,
              currency: "EUR",
            },
            discount: {
              percent_off: 10,
            },
          },
        },
        items: [
          {
            option_id: 4650,
            title: "packs",
            required: true,
            type: "multi",
            qty: 10,
            __typename: "BundleItem",
            sku: "sticks-carton-amber-subscription",
            options: [
              {
                id: 4735,
                label: "Camel Amber - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13604,
                  name: "Camel Amber - Pack",
                  sku: "sticks-pack-amber",
                  flavor: 16,
                  stock_status: "IN_STOCK",
                  color_label: "",
                  flavour_details: [
                    {
                      name: "Amber",
                      description: "Stronger fresh kick",
                      attributes: [
                        {
                          id: 13,
                          name: "Intensity",
                          sort_order: 22,
                          value: "0.5",
                        },
                        {
                          id: 14,
                          name: "Flavor",
                          sort_order: 23,
                          value: "4.5",
                        },
                        {
                          id: 15,
                          name: "Strength",
                          sort_order: 24,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                  },
                  media_gallery: [
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_1.jpg",
                      role: [],
                    },
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                  ],
                  categories: [],
                  __typename: "SimpleProduct",
                },
              },
            ],
            all_options: [
              {
                id: 4735,
                label: "Camel Amber - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13604,
                  name: "Camel Amber - Pack",
                  sku: "sticks-pack-amber",
                  flavor: 16,
                  stock_status: "IN_STOCK",
                  color_label: "Red",
                  flavour_details: [
                    {
                      name: "Amber",
                      description: "Stronger fresh kick",
                      attributes: [
                        {
                          id: 13,
                          name: "Intensity",
                          sort_order: 22,
                          value: "0.5",
                        },
                        {
                          id: 14,
                          name: "Flavor",
                          sort_order: 23,
                          value: "4.5",
                        },
                        {
                          id: 15,
                          name: "Strength",
                          sort_order: 24,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                  },
                  media_gallery: [
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_1.jpg",
                      role: [],
                    },
                    {
                      label: null,
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 44.44,
                        currency: "EUR",
                      },
                      regular_price: {
                        value: 44.44,
                        currency: "EUR",
                      },
                      discount: {
                        percent_off: 0,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
            ],
          },
        ],
      },
      {
        sku: "sticks-pack-amber",
        __typename: "SimpleProduct",
        id: 13604,
        name: "Camel Amber - Pack",
        stock_status: "IN_STOCK",
        flavor: 16,
        color: 29,
        categories: [],
        flavour_details: [
          {
            name: "Amber",
            description: "Stronger fresh kick",
            attributes: [
              {
                id: 13,
                name: "Intensity",
                sort_order: 22,
                value: "0.5",
              },
              {
                id: 14,
                name: "Flavor",
                sort_order: 23,
                value: "4.5",
              },
              {
                id: 15,
                name: "Strength",
                sort_order: 24,
                value: "2.5",
              },
            ],
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
        },
        media_gallery: [
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_1.jpg",
            role: [],
          },
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
            role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 44.44,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 88.88,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 133.32,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 177.76,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 222.2,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 44.44,
              currency: "EUR",
            },
            regular_price: {
              value: 44.44,
              currency: "EUR",
            },
            discount: {
              percent_off: 0,
            },
          },
        },
      },
      {
        sku: "consumables-sticks-pack-amber",
        __typename: "SimpleProduct",
        id: 13604,
        name: "Camel Amber - Pack",
        stock_status: "IN_STOCK",
        flavor: 16,
        color: 29,
        categories: [],
        flavour_details: [
          {
            name: "Amber",
            description: "Stronger fresh kick",
            attributes: [
              {
                id: 13,
                name: "Intensity",
                sort_order: 22,
                value: "0.5",
              },
              {
                id: 14,
                name: "Flavor",
                sort_order: 23,
                value: "4.5",
              },
              {
                id: 15,
                name: "Strength",
                sort_order: 24,
                value: "2.5",
              },
            ],
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
        },
        media_gallery: [
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_1.jpg",
            role: [],
          },
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
            role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 44.44,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 88.88,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 133.32,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 177.76,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 222.2,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 44.44,
              currency: "EUR",
            },
            regular_price: {
              value: 44.44,
              currency: "EUR",
            },
            discount: {
              percent_off: 0,
            },
          },
        },
      },
      {
        sku: "sticks-pack-silver",
        __typename: "SimpleProduct",
        id: 13601,
        name: "Camel Silver - Pack",
        stock_status: "IN_STOCK",
        flavor: 15,
        color: 18,
        categories: [],
        thumbnail: {
          url: "",
        },
        flavour_details: [
          {
            name: null,
            description: "Fresh kick",
            attributes: [],
          },
        ],
        media_gallery: [
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3.jpg",
            role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
          },
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
            role: [],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 33.33,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 66.66,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 99.99,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 133.32,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 166.65,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 33.33,
              currency: "EUR",
            },
            regular_price: {
              value: 33.33,
              currency: "EUR",
            },
            discount: {
              percent_off: 0,
            },
          },
        },
      },
      {
        sku: "consumables-sticks-pack-silver",
        __typename: "SimpleProduct",
        id: 13601,
        name: "Camel Silver - Pack",
        stock_status: "IN_STOCK",
        flavor: 15,
        color: 18,
        categories: [],
        thumbnail: {
          url: "",
        },
        flavour_details: [
          {
            name: null,
            description: "Fresh kick",
            attributes: [],
          },
        ],
        media_gallery: [
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3.jpg",
            role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
          },
          {
            label: null,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
            role: [],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 33.33,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 66.66,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 99.99,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 133.32,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 166.65,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 33.33,
              currency: "EUR",
            },
            regular_price: {
              value: 33.33,
              currency: "EUR",
            },
            discount: {
              percent_off: 0,
            },
          },
        },
      },
      {
        sku: "consumables-sticks-carton-bronze-subscription",
        __typename: "BundleProduct",
        id: 14359,
        name: "Consumables Camel Bronze - Carton - Subscription",
        stock_status: "IN_STOCK",
        flavor: 14,
        flavor_label: "Bronze",
        color: null,
        categories: [],
        flavour_details: [
          {
            name: "Bronze",
            description: "Smoother than you think",
            attributes: [
              {
                id: 2,
                name: "Flavor",
                sort_order: 3,
                value: "5",
              },
              {
                id: 1,
                name: "Intensity",
                sort_order: 6,
                value: "2.5",
              },
            ],
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/f15de9f7dcdbdd3bc8cc4e480a95f9a3/b/r/bronze_1_3.jpg",
        },
        media_gallery: [
          {
            label: "Consumables Camel Bronze - Carton - Subscription",
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/f15de9f7dcdbdd3bc8cc4e480a95f9a3/b/r/bronze_1_3.jpg",
            role: ["image", "small_image", "thumbnail"],
          },
        ],
        promotionalOffers: [],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 41.935483870968,
                currency: "EUR",
                multiplier: 1,
              },
              {
                value: 83.870967741935,
                currency: "EUR",
                multiplier: 2,
              },
              {
                value: 125.8064516129,
                currency: "EUR",
                multiplier: 3,
              },
              {
                value: 167.74193548387,
                currency: "EUR",
                multiplier: 4,
              },
              {
                value: 209.67741935484,
                currency: "EUR",
                multiplier: 5,
              },
            ],
            final_price: {
              value: 41.935483870968,
              currency: "EUR",
            },
            regular_price: {
              value: 41.935483870968,
              currency: "EUR",
            },
            discount: {
              percent_off: 0,
            },
          },
        },
        items: [
          {
            option_id: 4743,
            title: "packs",
            required: true,
            type: "multi",
            qty: 10,
            __typename: "BundleItem",
            sku: "consumables-sticks-carton-bronze-subscription",
            options: [
              {
                id: 4945,
                label: "Consumables Camel Bronze - Pack",
                qty: 10,
                quantity: 10,
                is_default: false,
                product: {
                  id: 14351,
                  name: "Consumables Camel Bronze - Pack",
                  sku: "consumables-sticks-pack-bronze",
                  flavor: 14,
                  flavor_label: "Bronze",
                  stock_status: "IN_STOCK",
                  color_label: "Soft Champagne",
                  flavour_details: [
                    {
                      name: "Bronze",
                      description: "Smoother than you think",
                      attributes: [
                        {
                          id: 2,
                          name: "Flavor",
                          sort_order: 3,
                          value: "5",
                        },
                        {
                          id: 1,
                          name: "Intensity",
                          sort_order: 6,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  media_gallery: [
                    {
                      label: "Consumables Camel Bronze - Pack",
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/f15de9f7dcdbdd3bc8cc4e480a95f9a3/c/a/camel_bronze_5.png",
                      role: ["image", "small_image", "thumbnail", "swatch_image"],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 5.1612903225806,
                        currency: "EUR",
                      },
                      regular_price: {
                        value: 5.1612903225806,
                        currency: "EUR",
                      },
                      discount: {
                        percent_off: 0,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
            ],
            all_options: [
              {
                id: 4945,
                label: "Consumables Camel Bronze - Pack",
                qty: 10,
                quantity: 10,
                is_default: false,
                product: {
                  id: 14351,
                  name: "Consumables Camel Bronze - Pack",
                  sku: "consumables-sticks-pack-bronze",
                  flavor: 14,
                  flavor_label: "Bronze",
                  stock_status: "IN_STOCK",
                  color_label: "Soft Champagne",
                  flavour_details: [
                    {
                      name: "Bronze",
                      description: "Smoother than you think",
                      attributes: [
                        {
                          id: 2,
                          name: "Flavor",
                          sort_order: 3,
                          value: "5",
                        },
                        {
                          id: 1,
                          name: "Intensity",
                          sort_order: 6,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/f15de9f7dcdbdd3bc8cc4e480a95f9a3/c/a/camel_bronze_5.png",
                  },
                  media_gallery: [
                    {
                      label: "Consumables Camel Bronze - Pack",
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/f15de9f7dcdbdd3bc8cc4e480a95f9a3/c/a/camel_bronze_5.png",
                      role: ["image", "small_image", "thumbnail", "swatch_image"],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 5.1612903225806,
                        currency: "EUR",
                      },
                      regular_price: {
                        value: 5.1612903225806,
                        currency: "EUR",
                      },
                      discount: {
                        percent_off: 0,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
            ],
          },
        ],
      },
    ],
  },
});

export const getProductDetailsBySkuFormattedResponseMock = (): MagentoGetProductsDetails =>
  keysToCamelCase(getProductDetailsByResponseMock());
